export default __webpack_public_path__ + "static/media/Sunny_06.3e16625c.png";